import _forIn from 'lodash/forIn'
import _cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import store from '../store'
import i18next from 'i18next'
import Vue from 'vue'
import { $t } from '@/i18n'
import { callGetData, callPostData } from './callAxios'
import { deviseSimple } from '@/services/toolbox'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

/**
 * Retourne les annonces pour une recherche donnée.
 *
 * @returns {object}
 */
export async function getPosts (filters, portalId, broadcast) {
  const qs = require('qs')

  const sitimmoUser = store.getters.getSitimmoUser
  const user = store.getters.getUser

  const params = {
    params: formatFilters(filters, null, null, broadcast, sitimmoUser.univers, portalId),
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false })
    }
  }

  let url = '/annonce?champsRechercheLibre[]=ville&champsRechercheLibre[]=titre&champsRechercheLibre[]=reference'
  if (filters.activeSocialNetworks === true && user.socialNetworkIds.length > 0) {
    const codenamesCall = formatCodenamesCall()
    const codenames = codenamesCall[0]
    url = url + '&portalCodes[]=' + codenames
    let i = 0
    user.socialNetworkIds.forEach(function (element) {
      url = url + '&linkedPortals[' + i + ']=' + element
      i++
    })
    url = url + '&fields=reference,etat,titre,photoPrincipale' + '&linkedPortalsActive=1'
  }
  const response = await callGetData(HTTP_HYPER_ESPACE_BACKEND, url, params)
  if (response.data && response.status === 200) {
    return {
      total: response.data.total_items,
      list: response.data._embedded.annonce
    }
  }
  return response
}

export function formatCodenamesCall (bienVendus, withoutClap, edito, specificCodeName) {
  const user = store.getters.getUser
  const codenames = []
  const ids = []
  user.socialNetworkCodenames.forEach(function (element) {
    if (bienVendus) {
      if (element[1].includes('_BIENS_VENDUS')) {
        if (!(withoutClap === true && (element[1] === 'CLAP_VIDEO_IMMO' || element[1] === 'CLAP_VIDEO_VO'))) {
          codenames.push(element[1])
          ids.push(element[0])
        }
      }
    } else if (bienVendus === false && !edito) {
      if (!element[1].includes('_BIENS_VENDUS') && !element[1].includes('_EDITO')) {
        if (!(withoutClap === true && (element[1] === 'CLAP_VIDEO_IMMO' || element[1] === 'CLAP_VIDEO_VO'))) {
          codenames.push(element[1])
          ids.push(element[0])
        }
      }
    } else if (edito) {
      if (element[1].includes('_EDITO')) {
        if (!(withoutClap === true && (element[1] === 'CLAP_VIDEO_IMMO' || element[1] === 'CLAP_VIDEO_VO'))) {
          codenames.push(element[1])
          ids.push(element[0])
        }
      }
    } else if (specificCodeName) {
      if (element[1].includes(specificCodeName)) {
        if (!(withoutClap === true && (element[1] === 'CLAP_VIDEO_IMMO' || element[1] === 'CLAP_VIDEO_VO'))) {
          codenames.push(element[1])
          ids.push(element[0])
        }
      }
    } else {
      if (!(withoutClap === true && (element[1] === 'CLAP_VIDEO_IMMO' || element[1] === 'CLAP_VIDEO_VO'))) {
        codenames.push(element[1])
        ids.push(element[0])
      }
    }
  })

  if (codenames.length > 0) {
    return [codenames.join(','), ids]
  }
}

export function formatLinkedPortals () {
  const user = store.getters.getUser
  const codenames = []
  user.socialNetworkCodenames.forEach(function (element) {
    codenames.push(element[1])
  })
  if (codenames.length > 0) {
    return codenames.join(',')
  }
}

export async function getPostsAutocompletion (filters) {
  const posts = await getPosts(filters)
  const list = []
  if (posts.list) {
    posts.list.forEach(function (post) {
      const temp = {
        post: post,
        value: post.reference + ' - ' + post.titre
      }
      list.push(temp)
    })
  }
  return list
}

export async function getPostsCommercials (filters) {
  let url = '/annonces-commerciaux'
  if (filters.sort) {
    url += '?sort=' + filters.sort
  }
  const response = await callGetData(HTTP_HYPER_ESPACE_BACKEND, url, filters)
  return response.data
}

export async function createPost (post, username, codeFlux) {
  if (post.afficher_prix === 'non') {
    post.prix_prive = post.prix
  }

  if (!post.reference) {
    post.reference = moment().format('YYMMDD-HHmmss')
  }

  post = handlePost(post)
  const clonedPost = _cloneDeep(post)
  const clonedPictures = await getBase64Pictures(clonedPost.photos)

  clonedPost.type_objet = clonedPost.typeObjet
  clonedPost.type_offre = clonedPost.typeOffre
  clonedPost.code_type = clonedPost.typeObjet
  clonedPost.code_type = clonedPost.typeObjet
  clonedPost.photos = null

  if (codeFlux !== 'SAISIE_VO' && clonedPost.etat) {
    clonedPost.STATUS = clonedPost.etat
    delete clonedPost.etat
  }
  if (codeFlux === 'SAISIE_VO' && clonedPost.etat_produit) {
    clonedPost.STATUS = clonedPost.etat
    clonedPost.etat = clonedPost.etat_produit
  }
  if (codeFlux === 'SAISIE_VO' && (clonedPost.equipments === '' || clonedPost.equipments === null)) {
    delete clonedPost.equipments
  }
  if (codeFlux === 'SAISIE_VO' && (clonedPost.equipements_non_qualifies === '' || clonedPost.equipements_non_qualifies === null)) {
    delete clonedPost.equipements_non_qualifies
  }

  const data = {
    annonceur: {
      login: username
    },
    flux: {
      code: codeFlux
    },
    annonce: clonedPost,
    pictures: clonedPictures,
    attachedFiles: clonedPost.attachedFiles,
    lang: i18next.language
  }

  const response = await callPostData(HTTP_HYPER_ESPACE_BACKEND, '/annonce', data)
  if (response.data) {
    return { type: 'success', message: 'Votre annonce a bien été créée', ad: response.data.ad }
  } else {
    return { type: 'error', message: response.error }
  }
}

export async function deletePost (postId) {
  return HTTP_HYPER_ESPACE_BACKEND
    .delete('/annonce/' + postId)
    .then(response => {
      return { type: 'success', message: 'Votre annonce a bien été supprimée' }
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function deleteAllPosts (posts) {
  const params = {
    data: posts
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .delete('/annonce', params)
    .then(response => {
      return { type: 'success', message: $t('validator.addDelete') }
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export function handlePost (post) {
  post = checkDateDPEDateIndice(post)
  if (post.loyer_mensuel_cc && post.loyer_est_cc && post.loyer_est_cc === 'non') {
    delete post.loyer_mensuel_cc
  }
  // if (post.dpe_vierge && post.dpe_vierge === 'oui' && post.soumis_dpe) {
  //   delete post.soumis_dpe
  // }
  return post
}

export function checkDateDPEDateIndice (post) {
  let checkDateDpe2021 = false
  if (post.dpe_date_realisation) {
    const formatDateDpe = moment(post.dpe_date_realisation, 'DD/MM/YYYY')
    checkDateDpe2021 = moment(formatDateDpe).isAfter('2021-07-01')
  }
  if (checkDateDpe2021) {
    delete post.date_indice_prix_energies
  }
  return post
}

export async function updatePost (post, username, codeFlux, flux = null) {
  if (post.afficher_prix === 'non') {
    post.prix_prive = post.prix
  }
  if (post.modele) {
    post.modele_brute = post.modele
  }
  post = handlePost(post)
  // we cannot send a post.etat like 'A' because a data 'etat' already exists for VO
  // see in flatPost(): etat -> etat_produit
  if (codeFlux === 'SAISIE_VO') {
    post.etat = Object.prototype.hasOwnProperty.call(post, 'etat_produit') ? post.etat_produit : ''
  } else {
    delete post.etat
  }

  // clone without referencing
  const clonedPost = _cloneDeep(post)
  const pictures = await getBase64Pictures(clonedPost.photos)

  clonedPost.type_objet = clonedPost.typeObjet
  clonedPost.type_offre = clonedPost.typeOffre
  clonedPost.code_type = clonedPost.typeObjet
  if (!clonedPost.annonce_parente_reference && clonedPost.parentAd && clonedPost.parentAd.reference) {
    clonedPost.annonce_parente_reference = clonedPost.parentAd.reference
  }

  if (pictures) {
    pictures.forEach(function (value, i) {
      delete clonedPost['photo_' + (i + 1)]
    })
  }

  if (codeFlux === 'SAISIE_VO' && (clonedPost.equipments === '' || clonedPost.equipments === null)) {
    delete clonedPost.equipments
  }
  if (codeFlux === 'SAISIE_VO' && (clonedPost.equipements_non_qualifies === '' || clonedPost.equipements_non_qualifies === null)) {
    delete clonedPost.equipements_non_qualifies
  }

  delete clonedPost.photos
  delete clonedPost.photoPrincipale
  if (clonedPost.couleur_brute) {
    delete clonedPost.couleur_brute
  }
  if (clonedPost.vente_prix_reel) {
    delete clonedPost.vente_prix_reel
  }
  if (clonedPost.vente_prix_reel) {
    delete clonedPost.vente_prix_reel
  }

  let data = null
  data = {
    annonceur: {
      login: username
    },
    flux: {
      code: codeFlux
    },
    annonce: clonedPost,
    pictures: pictures,
    attachedFiles: clonedPost.attachedFiles,
    lang: i18next.language
  }
  return HTTP_HYPER_ESPACE_BACKEND
    .put('/annonce/' + clonedPost.id, data)
    .then(response => {
      return { type: 'success', message: 'Votre annonce a bien été mise à jour', ad: response.data.ad }
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

// Only for patch, do not use this with an update purpose
export async function patchPost (post, username, codeFlux, flux = null, idFlux = null) {
  let data = null

  data = {
    annonceur: {
      login: username
    },
    flux: {
      code: codeFlux
    },
    annonce: post
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .patch('/annonce/' + post.id, data)
    .then(response => {
      return { type: 'success', message: 'Votre annonce a bien été mise à jour', ad: response.data.ad }
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

async function getBase64Pictures (pictures) {
  _forIn(pictures, async function (value, key) {
    if (value.type && value.type === 'base64') {
      pictures[key].value = pictures[key].url.replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
    } else {
      pictures[key].type = 'base64'
      pictures[key].value = pictures[key].url
      delete pictures[key].nom_source
      delete pictures[key].chaine_source
    }
    delete pictures[key].url
    delete pictures[key].url_miniature
  })

  return pictures
}

/**
 * Retourne les annonces pour une recherche donnée.
 *
 * @returns {object}
 */
export async function exportXlsPosts (filters, selectedIds, contacts, filename = null) {
  const sitimmoUser = store.getters.getSitimmoUser

  delete filters.page
  delete filters.perPage
  delete filters.limit

  let exportType = 'annonce_' + sitimmoUser.univers

  if (contacts) {
    exportType += '_MAILTRACKING'
  }

  const data = {
    filters: formatFilters(filters, contacts, selectedIds, null, sitimmoUser.univers),
    exportType: exportType,
    to: sitimmoUser.email,
    filename: filename,
    lang: i18next.language
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .post('/export_requests', data)
    .then(response => {
      if (response.status === 202) {
        return { type: 'success', message: $t('layouts.exportSuccess') }
      }
    })
    .catch(error => {
      console.log('error', error)
    })
}

/**
 * Retourne une annonce selon son identifiant.
 *
 * @param {string} postId
 * @returns {object}
 */
export async function getPostById (postId) {
  const params = {
    params: {
      lang: i18next.language
    }
  }
  const post = await callGetData(HTTP_HYPER_ESPACE_BACKEND, '/annonce/' + postId, params)
  return formatPostData(post)
}

export function formatPostData (post) {
  if (post.data) {
    if (post.data.prix === 'Nous consulter') {
      post.data.afficher_prix = 'non'
      post.data.prix = null
    } else if (post.data.prix && typeof post.data.prix === 'string' && post.data.prix !== 'Nous consulter') {
      post.data.prix = parseInt(post.data.prix)
    } else if (!post.data.prix && post.data.prix_prive) {
      post.data.prix = post.data.prix_prive
      post.data.afficher_prix = 'non'
    } else {
      post.data.afficher_prix = 'oui'
    }
    if (post.data.typeOffre === 'L') { // because of this fucking dumb ubiflow api - 57826
      post.data.loyer_mensuel = post.data.prix
    }
    return flatPost(post.data)
  } else {
    return null
  }
}

/**
 * Retourne une annonce selon son identifiant.
 *
 * @param {string} postId
 * @returns {object}
 */
export async function getPostByReference (reference) {
  const response = await callGetData(HTTP_HYPER_ESPACE_BACKEND, '/annonce?reference=' + reference)
  if (response.data && response.data._embedded) {
    return response.data._embedded.annonce[0]
  }
}

export async function getDefinitionDonneeListeeByCode (payload) {
  const params = {
    params: {
      codes: payload.codes.toString(),
      lang: i18next.language
    }
  }

  const response = await callGetData(HTTP_HYPER_ESPACE_BACKEND, '/definition-donnee-listee', params)
  if (response.data && response.data._embedded) {
    return response.data._embedded.definition_donnee_listee
  }
}

export function flatPost (post) {
  _forIn(post.donnees, function (value, key) {
    if (key === 'etat') {
      post.etat_produit = value.valeur
    } else {
      if (value.flux !== 'ENRICHISSEMENT_UBIFLOW') {
        post[key] = value.valeur
      }
    }
  })

  if (!post.code_postal_reel && post.code_postal) {
    post.code_postal_reel = post.code_postal
  }

  // Get equipments for vehicles
  post.equipments = getEquipmentsVehicle(post)

  if (post.equipments === '') {
    delete post.equipments
  }

  if (post.financement_mensualites) {
    post.prixDisplay = post.financement_apport + ' ' + deviseSimple(post.devise_iso_4217) + ' + ' + post.financement_mensualites + ' ' + deviseSimple(post.devise_iso_4217) + ' / ' + $t('general.month')
  }

  // Gestion texte local pour ne pas écraser celui d'origine
  post.localText = post.texte

  delete post.donnees
  delete post.ville_insee
  delete post.ville_insee_exacte
  return post
}

/**
 * Bascule une annonce dans un état publié ou non.
 */
export async function setPostPublishedState (selectedIds, id, codeFlux) {
  if (id != null) {
    selectedIds = new Array(id)
  }

  const annonces = await getPostsSelectedIds(selectedIds)

  const urlsPatch = []
  const sitimmoUser = store.getters.getSitimmoUser
  if (annonces) {
    for (const annonce of annonces) {
      const state = annonce.etat === 'A' ? 'B' : 'A'
      const data = {
        annonceur: {
          id: sitimmoUser.id
        },
        flux: {
          code: codeFlux
        },
        annonce: {
          STATUS: state
        }
      }
      urlsPatch.push({
        url: '/annonce/' + annonce.id,
        data: data
      })
    }
  }

  const promiseArrPatch = urlsPatch.map(urlPatch => {
    return HTTP_HYPER_ESPACE_BACKEND.patch(urlPatch.url, urlPatch.data)
  })

  return Promise.all(promiseArrPatch)
    .then(() => {
      return { type: 'success' }
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function getPostsSelectedIds (selectedIds) {
  const result = await HTTP_HYPER_ESPACE_BACKEND.get('/annonce?ids=' + selectedIds)
  if (result.data._embedded) {
    return result.data._embedded.annonce
  }
}

export function addRuleSurface (payload, rules) {
  if ((payload >= 2000 && payload < 3000) || payload === 3300 || payload === 4400) {
    if (payload >= 2300 && payload < 2500 && payload !== 2410) {
      rules.surface_commerciale = [{ required: true, message: $t('validator.isRequired'), trigger: 'blur' }]
    } else if (payload === 2410 || payload === 3400 || payload === 4400) {
      rules.surface_bureaux = [{ required: true, message: $t('validator.isRequired'), trigger: 'blur' }]
    } else {
      rules.surface_activite = [{ required: true, message: $t('validator.isRequired'), trigger: 'blur' }]
    }
  } else {
    if ((payload >= 1300 && payload < 1400) || payload === 3300) {
      rules.surface_terrain = [{ required: true, message: $t('validator.isRequired'), trigger: 'blur' }]
    } else if (payload >= 1400 && payload < 1500) {
      rules.surface_stationnement = [{ required: true, message: $t('validator.isRequired'), trigger: 'blur' }]
    } else if (payload >= 3000 && payload <= 5000 && payload !== 3400 && payload !== 4400) {
      rules.surface_min = [{ required: true, message: $t('validator.isRequired'), trigger: 'blur' }]
    } else {
      rules.surface_habitable = [{ required: true, message: $t('validator.isRequired'), trigger: 'blur' }]
    }
  }
  return rules
}

export async function updateMultiplePosts (selectedIds, id, codeFlux, dataPost) {
  if (id != null) {
    selectedIds = new Array(id)
  }

  const annonces = await getPostsSelectedIds(selectedIds)
  const urlsPatch = []
  for (const annonce of annonces) {
    const data = {
      annonceur: {
        id: store.getters.getSitimmoUser.id
      },
      flux: {
        code: codeFlux
      },
      annonce: dataPost
    }
    urlsPatch.push({
      url: '/annonce/' + annonce.id,
      data: data
    })
  }
  const promiseArrPatch = urlsPatch.map(urlPatch => {
    return HTTP_HYPER_ESPACE_BACKEND.patch(urlPatch.url, urlPatch.data)
  })

  return Promise.all(promiseArrPatch)
    .then(() => {
      return { type: 'success' }
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

/**
 * Set state of the givens ads id
 * @param ids
 * @param state
 * @returns {Promise<void>}
 */
export async function setAdsState (id, codeFlux, state) {
  const sitimmoUser = store.getters.getSitimmoUser

  const data = {
    annonceur: {
      id: sitimmoUser.id
    },
    flux: {
      code: codeFlux
    },
    annonce: {
      STATUS: state
    }
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .patch('/annonce/' + id, data)
    .then(response => {
      return response.data
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export function checkMeuble (post) {
  const typesMeubles = [1100, 1200, 2100, 2200, 2300, 2400, 4100, 4200]
  if (typesMeubles.indexOf(post.type_objet) && !post.meuble) {
    post.meuble = 'non'
  }
  return post
}

export async function deleteModel (id) {
  return HTTP_HYPER_ESPACE_BACKEND
    .delete('/annonce/' + id)
    .then(post => {
      return post.status
    })
    .catch(error => {
      // this.errored = true
      return { type: 'error', message: error }
    })
}

export async function getDefinitionDonnees (codes) {
  const params = {
    params: {
      codes: codes.toString(),
      lang: i18next.language
    }
  }

  const response = await callGetData(HTTP_HYPER_ESPACE_BACKEND, '/definition-donnee', params)
  if (response.data && response.data._embedded) {
    return response.data._embedded.definition_donnee
  }
}

export function estBoolean (parentsValeur) {
  if (typeof parentsValeur === 'boolean') {
    if (parentsValeur) {
      return 'oui'
    } else {
      return 'non'
    }
  } else {
    return parentsValeur
  }
}

/**
 * Contrôle si la valeur est ou non un boolean
 */
export function loadDefinitionDonneesLabels () {
  getDefinitionDonnees('').then(
    response => {
      const labels = {}
      for (const dd of response) {
        const nomDeCode = dd.code.toLowerCase()
        let libelle = dd.libelle
        libelle = libelle.charAt(0).toUpperCase() + libelle.slice(1)
        labels[nomDeCode] = libelle
      }

      // we save the result globally
      Vue.prototype.$labels = labels
    }
  )
}

/**
 * Crée une nouvelle annonce à partir d'une annonce existante
 *
 * @param {string} postId
 * @param referenceDuplication
 * @returns {object}
 *
 */
export async function duplicatePost (postId, referenceDuplication) {
  if (!referenceDuplication) { referenceDuplication = '' }

  return HTTP_HYPER_ESPACE_BACKEND
    .get('/dupliquer_annonce?annonce=' + postId + '&reference=' + referenceDuplication)
    .then(post => {
      return post.data
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

/**
 * Crée une nouvelle annonce à partir d'un modèle de terrain et d'un modèle de maison
 *
 * @returns {object}
 *
 * @param postLandId
 * @param postHouseId
 * @param reference
 */
export async function mergePost (postLandId, postHouseId, reference = null) {
  if (!reference == null) {
    reference = ''
  }
  return HTTP_HYPER_ESPACE_BACKEND
    .get('/dupliquer_annonce?annonce=' + postHouseId + '&additionalAds[]=' + postLandId + '&reference=' + reference)
    .then(post => {
      return post.data
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

/**
 * Retourne les marques de véhicule d'un type objet.
 *
 * @param {string} brand
 * @returns {object}
 */
export async function getBrandsOfObjectType (objectType, showTopBrands) {
  // we get all the objectTypes: current objectType and its parents
  const objectTypes = []
  objectTypes.push(objectType)
  await HTTP_HYPER_ESPACE_BACKEND.get('/type_objet?codes=' + objectType)
    .then(response => {
      const parentCodes = Object.values(response.data._embedded.type_objet[0].parentCodes)
      parentCodes.forEach(parentCode => objectTypes.push(parentCode))
    }).catch(error => {
      return 'Erreur'
    })

  // for each objectType we get create the url to get the corresponding brands
  const urls = []
  for (const objType of objectTypes) {
    urls.push('/definition-donnee-listee?codes=MARQUE&dataCondition=CATEGORIE&dataValue=' + objType)
  }
  // we collect all the brands in an unique array by doing axios requests in parallel.
  const brands = []
  const promiseArr = urls.map(url => {
    return HTTP_HYPER_ESPACE_BACKEND.get(url)
      .then(response => {
        const elementsOrdered = response.data._embedded.definition_donnee_listee[0].elementsOrdered
        const arrayElementsOrdered = Object.values(elementsOrdered)
        arrayElementsOrdered.forEach(el => brands.push(el))
      })
  })
  await Promise.all(promiseArr)
    .catch(error => {
      return { type: 'error', message: error }
    })

  // remove duplicates, sort alphabetically and then by order
  const map = {}
  const uniqueBrands = []
  brands.forEach(el => {
    if (el.order === null) {
      el.order = 10000 // to sort them next
    }
    if (!map[JSON.stringify(el)]) {
      map[JSON.stringify(el)] = true
      uniqueBrands.push(el)
    }
  })
  uniqueBrands.sort((a, b) => (a.value > b.value) ? 1 : -1)
  if (showTopBrands) {
    uniqueBrands.sort((a, b) => (a.order >= b.order) ? 1 : -1)
    // add the separation between top brands and other brands
    const index = uniqueBrands.findIndex(el => {
      return el.order === 10000
    })
    uniqueBrands.splice(index, 0, { value: '--------------------------------', order: 10000 })
  }

  // we must return a string array
  const brandsString = []
  uniqueBrands.forEach(el => brandsString.push(el.value))

  return brandsString
}

/**
 * Retourne les modèles d'une marque de véhicule.
 *
 * @param {string} brand
 * @returns {object}
 */
export function getModelsOfBrand (brand) {
  const brandEncoded = encodeURIComponent(brand)
  return HTTP_HYPER_ESPACE_BACKEND
    .get('/definition-donnee-listee?codes=MODELE&dataCondition=MARQUE&dataValue=' + brandEncoded)
    .then(response => {
      return response.data._embedded.definition_donnee_listee[0].values
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function getPostsByRefs (refs, filter) {
  const data = {
    refs: refs,
    offset: filter.offset,
    perPage: filter.limit,
    page: filter.page
  }

  const url = '/annonce'

  const params = {
    params: data
  }

  const response = await callGetData(HTTP_HYPER_ESPACE_BACKEND, url, params)
  if (response.data && response.data._embedded) {
    return {
      total: response.data.total_items,
      list: response.data._embedded.annonce
    }
  }
}

export async function fetchMentionsLegales () {
  const url = '/mentions-legales'

  const response = await callGetData(HTTP_HYPER_ESPACE_BACKEND, url)
  if (response.data && response.data._embedded) {
    return {
      list: response.data._embedded.mentions_legales
    }
  }
}

export async function deleteMentionsLegales (id) {
  const url = '/mentions-legales/' + id

  return HTTP_HYPER_ESPACE_BACKEND
    .delete(url)
    .then(mentionsLegales => {
      return mentionsLegales
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function saveMentionLegale (titre, texte) {
  const data = {
    titre: titre,
    texte: texte
  }

  const url = '/mentions-legales'

  return HTTP_HYPER_ESPACE_BACKEND
    .post(url, data)
    .then(mentionsLegales => {
      return {
        status: mentionsLegales.status
        // list: mentions_legales.data._embedded.mentions_legales
      }
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export function getEquipmentsVehicle (post) {
  let equipements = ''
  const excludedKeys = ['avec_direction_assistee', 'roues_motrices', 'vehicule_distribution_type', 'equipements']
  if (post.donnees) {
    const donnees = post.donnees
    let i = 0
    for (const [key, value] of Object.entries(donnees)) {
      if (value.famille.substr(0, 5) === 'Equip' && value.valeur !== '' && !excludedKeys.includes(key)) {
        if (i > 0) {
          equipements = equipements + ', '
        }

        equipements = equipements + formatEquipmentExceptions(value, i, key)
        i = i + 1
      }
    }
  }

  return equipements
}

export function formatEquipmentExceptions (object, counter, key) {
  if (key === 'roues_motrices') {
    return object.valeur + ' ' + 'roues motrices'
  } else {
    return object.libelle
  }
}

export async function updateMentionLegale (id, titre, texte) {
  const data = {
    titre: titre,
    texte: texte
  }

  const url = '/mentions-legales/' + id

  return HTTP_HYPER_ESPACE_BACKEND
    .put(url, data)
    .then(mentionsLegales => {
      return mentionsLegales
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function getPostByRef (ref) {
  const url = '/annonce?reference=' + ref + '&annonceur=' + store.getters.getUser.id +
      '&etat=A,S,B,M'

  const response = await callGetData(HTTP_HYPER_ESPACE_BACKEND, url)
  if (response.data && response.data._embedded) {
    return {
      total: response.data.total_items,
      list: response.data._embedded.annonce
    }
  }
}

export async function getNbTotalProgrammes (annonceur, quotaUser) {
  let url = '/annonce?annonceur=' + annonceur + '&typeObjets=3000,5000&perPage=2'
  const user = store.getters.getUser
  if (quotaUser && Object.prototype.hasOwnProperty.call(user, 'identifierCode') && Object.prototype.hasOwnProperty.call(user, 'identifierValue')) {
    url = url + '&dataValues[USER_DATA_CODE]=' + user.identifierCode
    url = url + '&dataValues[USER_DATA_VALUE]=' + user.identifierValue
  }
  const response = await callGetData(HTTP_HYPER_ESPACE_BACKEND, url)
  if (response.data) {
    return response.data.total_items
  }
}

export async function getNbTotalLots (annonceur, quotaUser) {
  // https://ubiflow-api.ubiflow.net/annonce?annonceur=ag351950&typeObjets=1000&perPage=2
  let url = '/annonce?annonceur=' + annonceur + '&typeObjets=1000,4000&perPage=2'
  const user = store.getters.getUser
  if (quotaUser && Object.prototype.hasOwnProperty.call(user, 'identifierCode') && Object.prototype.hasOwnProperty.call(user, 'identifierValue')) {
    url = url + '&dataValues[USER_DATA_CODE]=' + user.identifierCode
    url = url + '&dataValues[USER_DATA_VALUE]=' + user.identifierValue
  }
  return HTTP_HYPER_ESPACE_BACKEND
    .get(url)
    .then(result => {
      return result.data.total_items
    })
}

export async function getNbTotalLotsProgramme (annonceParente, portalId) {
  let url = '/annonce?annonce_parente=' + annonceParente + '&limit=2'

  if (portalId != null) {
    url = url + '&linkedPortals[]=' + portalId
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .get(url)
    .then(result => {
      return result.data.total_items
    })
}

export async function getNbTotalLotsCochesProgramme (annonceParente, portalId) {
  // https://ubiflow-api.ubiflow.net/annonce?annonceur=ag351950&typeObjets=1000&limit=2
  let url = '/annonce?typeObjets=1000,4000&annonce_parente=' + annonceParente + '&limit=2&etat=A'

  if (portalId != null) {
    url = url + '&linkedPortals[]=' + portalId + '&linkedPortalsActive=1'
  }
  return HTTP_HYPER_ESPACE_BACKEND
    .get(url)
    .then(result => {
      return result.data.total_items
    })
}

export async function getNbProgrammesActifs (annonceur, idPortail, quotaUser) {
  // https://ubiflow-api.ubiflow.net/annonce?annonceur=ag351950&typeObjets=3000&linkedPortals[]=683&linkedPortalsActive=1&perPage=2
  let url = '/annonce?annonceur=' + annonceur + '&typeObjets=3000,5000&linkedPortals[]=' +
      idPortail + '&linkedPortalsActive=1&&perPage=2'
  const user = store.getters.getUser
  if (quotaUser && Object.prototype.hasOwnProperty.call(user, 'identifierCode') && Object.prototype.hasOwnProperty.call(user, 'identifierValue')) {
    url = url + '&dataValues[USER_DATA_CODE]=' + user.identifierCode
    url = url + '&dataValues[USER_DATA_VALUE]=' + user.identifierValue
  }
  return HTTP_HYPER_ESPACE_BACKEND
    .get(url)
    .then(result => {
      return result.data.total_items
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function getNbLotsActifs (annonceur, idPortail, quotaUser) {
  // https://ubiflow-api.ubiflow.net/annonce?annonceur=ag351950&typeObjets=1000&linkedPortals[]=683&linkedPortalsActive=1&perPage=2
  let url = '/annonce?annonceur=' + annonceur + '&typeObjets=1000,4000&linkedPortals[]=' +
      idPortail + '&linkedPortalsActive=1&perPage=2'
  const user = store.getters.getUser
  if (quotaUser && Object.prototype.hasOwnProperty.call(user, 'identifierCode') && Object.prototype.hasOwnProperty.call(user, 'identifierValue')) {
    url = url + '&dataValues[USER_DATA_CODE]=' + user.identifierCode
    url = url + '&dataValues[USER_DATA_VALUE]=' + user.identifierValue
  }
  return HTTP_HYPER_ESPACE_BACKEND
    .get(url)
    .then(result => {
      return result.data.total_items
    })
}

export function checkedPromoteurLot (post, checked) {
  for (const [key, value] of Object.entries(post)) {
    if (post[key] === 'oui') { checked[key] = true }
  }

  checked = Object.fromEntries(checked)

  return checked
}

export function duplicateFromParent (parent, post) {
  for (const [key, value] of Object.entries(parent)) {
    post[key] = estBoolean(value)
  }

  if (parent.texte && !post.texte) {
    post.texte = parent.texte
  }

  delete post.prix
  delete post.afficher_prix
  delete post.titre
  delete post.id
  delete post.reference

  return post
}

export function filtersGetState (filters) {
  let etat = 'A,M,B'
  const sitimmoUser = store.getters.getSitimmoUser
  if (sitimmoUser.soldProductsOption && sitimmoUser.soldProductsOption === true) {
    etat = 'A,V,M,B'
  }
  if (filters.annoncesDesactivees === true) {
    etat = 'B'
  } else if (filters.annoncesModeles === true) {
    etat = 'M'
  } else if (filters.annoncesActivees === true) {
    etat = 'A'
  } else if (filters.annoncesSupprimees === true) {
    etat = 'S'
  }
  if (filters.annoncesVendues === true) {
    etat = 'V'
  }
  return etat
}

export function formatFilters (filters, contacts, selectedIds, broadcast, univers, portalId = null) {
  const user = store.getters.getUser
  const normalizedFilters = {}
  normalizedFilters.idAnnonceur = user.advertiser
  if (portalId) {
    normalizedFilters.diffuseur = portalId
  }
  if (filters.annoncesDesactivees === true) {
    normalizedFilters.annoncesDesactivees = 'O'
  }
  if (filters.annoncesModeles === true) {
    normalizedFilters.annoncesModeles = 'O'
  }
  if (filters.annoncesActivees === true) {
    normalizedFilters.annoncesActivees = 'O'
  }
  if (filters.annoncesVendues === true) {
    normalizedFilters.annoncesActivees = null
    normalizedFilters.annoncesVendues = 'O'
  }
  if (filters.marchand_vo) {
    normalizedFilters.emetteurCode = filters.marchand_vo
  }
  if (filters.annonceParente && filters.annonceParente != null) {
    normalizedFilters.annonce_parente = filters.annonceParente
  } else {
    // Dans la base sitimmo si pas d'annonce parente, la valeur par défaut est à zéro. On met plusieurs zéro pour
    // que l'API reconnaisse la valeur numérique et pas un booléen
    normalizedFilters.annonce_parente = '00'
  }
  normalizedFilters.etat = filtersGetState(filters)

  if (contacts === true) {
    if (filters.beforeContacts != null) {
      const dateBefore = moment(filters.beforeContacts).format('YYYY-MM-DD')
      normalizedFilters.dateMinContact = dateBefore
      normalizedFilters.dateMin = dateBefore
    } else {
      const dateBefore = moment().subtract(7, 'days')
      const before = moment(dateBefore).format('YYYY-MM-DD')
      normalizedFilters.dateMinContact = before
      normalizedFilters.dateMin = before
    }

    if (filters.afterContacts != null) {
      const dateAfter = moment(filters.afterContacts).format('YYYY-MM-DD')
      normalizedFilters.dateMaxContact = dateAfter
      normalizedFilters.dateMax = dateAfter
    }
  }

  if (selectedIds != null) {
    normalizedFilters.ids = selectedIds
  }
  for (const [key, value] of Object.entries(filters)) {
    switch (key) {
      case 'offset':
        break
      case 'limit':
        normalizedFilters.perPage = value
        break
      case 'page':
        normalizedFilters.page = value
        break
      case 'offerTypes':
        normalizedFilters.typeOffres = value
        break
      case 'objectTypes':
        normalizedFilters.typeObjets = value
        break
      case 'surfaceGt':
        if (univers !== 'VO') {
          normalizedFilters.surfaceGt = value
        }
        break
      case 'surfaceLt':
        if (univers !== 'VO') {
          normalizedFilters.surfaceLt = value
        }
        break
      case 'marque':
        if (univers === 'VO') {
          normalizedFilters.marque = value
        }
        break
      case 'modele':
        if (univers === 'VO') {
          normalizedFilters.modele = value
        }
        break
      case 'dateCreationGt':
        if (value != null) {
          const before = moment(value).format('DD/MM/YYYY')
          normalizedFilters.dateCreationGt = before
        }
        break
      case 'millesime':
        if (univers === 'VO') {
          normalizedFilters.millesime = Number(value)
        }
        break
      case 'dateCreationLt':
        if (value != null) {
          const after = moment(value).add(1, 'd')
          normalizedFilters.dateCreationLt = moment(after).format('DD/MM/YYYY')
        }
        break
      case 'priceGt':
        normalizedFilters.prixGt = Number(value)
        break
      case 'priceLt':
        normalizedFilters.prixLt = Number(value)
        break
      case 'mandates':
        if (univers !== 'VO') {
          normalizedFilters.mandat = value
        }
        break
      case 'search':
        normalizedFilters.rechercheLibre = value
        break
      case 'orderBy':
        normalizedFilters.orderBy = value
        break
      case 'sort':
        normalizedFilters.orderBy = value
        break
      case 'linkedPortals':
        normalizedFilters.linkedPortals = value
        break
      case 'withoutPictures':
        if (value === true) {
          normalizedFilters.sansPhoto = 'O'
        }
        break
      default:
        normalizedFilters[key] = value
        break
    }
  }

  if (normalizedFilters.etat.length === 0) {
    normalizedFilters.etat = 'A,B,M,V'
  }
  // we add the language to params
  normalizedFilters.lang = i18next.language

  normalizedFilters.dataValues = {}

  // filter for multi-user to only get posts of simple users
  if (store.getters.isSubUser && Object.prototype.hasOwnProperty.call(user, 'identifierCode') && Object.prototype.hasOwnProperty.call(user, 'identifierValue') && !filters.annoncesModeles) {
    normalizedFilters.dataValues.USER_DATA_CODE = user.identifierCode
    normalizedFilters.dataValues.USER_DATA_VALUE = user.identifierValue
  } else {
    delete normalizedFilters.dataValues.USER_DATA_CODE
    delete normalizedFilters.dataValues.USER_DATA_VALUE
  }
  // filtre sur carnet de contact
  if (filters.contact !== '') {
    normalizedFilters.dataValues.CONTACT_A_AFFICHER = filters.contact
  } else {
    delete normalizedFilters.dataValues.CONTACT_A_AFFICHER
  }
  // filtre pour la sélection VO
  if (filters.selectionVo === true) {
    normalizedFilters.selectionVo = 'O'
  } else {
    delete normalizedFilters.selectionVo
  }
  if (filters.annoncesDiffusees) {
    normalizedFilters.annoncesDiffusees = filters.annoncesDiffusees
  } else {
    delete normalizedFilters.annoncesDiffusees
  }
  if (filters.withoutContact === true) {
    normalizedFilters.withoutContact = true
  }
  if (filters.fields) {
    normalizedFilters.fields = filters.fields
  }
  return normalizedFilters
}

export async function fetchSocialPosts (filters) {

  filters.activeSocialNetworks = true
  filters.linkedPortalsActive = 1

  const posts = await getPosts(filters)
  return posts
}
